import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import Typography from "@mui/material/Typography";

// Mui
import SaveIcon from "@mui/icons-material/Save";
import { Grid, Select } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import _ from "lodash";

// Navigate
import { useNavigate } from "react-router-dom";

//Mui Icon
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

// Components
import RoleManageCreateDialog from "@/components/Dialog/roleManageCreateDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import {
  getAccessControl,
  getControlCategory,
  getDepartment,
  getRoleType,
  updateAccessControl,
} from "@/fetch/fetchType";

// Config
// import connectConfig from "@/config/connectConfig";
// import { exportCSVFile } from "@/config/csvConfig";
// import { CustomerDailyTableColumn } from "@/config/tableColumnConfig";

// create  a header for csv library

const RoleAccessManagePage = (props) => {
  const { open, setOpen } = props;
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  // Navigate
  const navigate = useNavigate();

  // States
  const [editCount, setEditCount] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [roleDialog, setRoleDialog] = React.useState({
    open: false,
  });
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [selectedDept, setSelectedDept] = React.useState(1);
  const [department, setDepartment] = React.useState([]);
  const [accessControl, setAccessControl] = React.useState({
    permission: [],
    roleType: [],
    category: [],
  });

  // Fetch
  const fetchDept = async () => {
    const { data: department } = await getDepartment();
    setDepartment(department);
  };
  const fetchAll = async () => {
    setIsLoading(true);

    const { data: permission } = await getAccessControl(selectedDept);

    const { data: roleType } = await getRoleType(selectedDept);

    const { data: controlCategory } = await getControlCategory();
    const parent = _.filter(controlCategory, (c) => c.parent_id === 0);
    const category = _.map(parent, (p) => {
      return {
        ...p,
        child: _.filter(controlCategory, (c) => c.parent_id === p.id),
      };
    });
    const orderedCategory = [];
    _.forEach(category, (c) => {
      orderedCategory.push(c);
      _.forEach(c.child, (child) => {
        orderedCategory.push(child);
      });
    });

    setAccessControl({
      permission: [...permission],
      roleType: [...roleType],
      category: [...orderedCategory],
    });
    setIsLoading(false);
  };
  const handlePermissionClick = (e, targetObject, roleItem, categoryItem) => {
    const copyPermission = [...accessControl.permission];
    if (!targetObject) {
      const newObject = {
        id: generateMaxId(),
        role_id: roleItem.id,
        control_id: categoryItem.id,
        is_active: true,
        actions: categoryItem.actions,
      };
      setAccessControl((prev) => ({
        ...prev,
        permission: [...prev.permission, newObject],
      }));

      if (categoryItem.parent_id === 0) {
        const filterCategory = _.filter(accessControl.category, (category) => {
          return category.parent_id === categoryItem.id;
        });
        _.forEach(filterCategory, (category) => {
          let actions = {};
          _.map(category.actions, (name, key) => {
            actions[key] = true;
          });
          const newObject = {
            id: generateMaxId(),
            role_id: roleItem.id,
            control_id: category.id,
            is_active: true,
            actions: actions,
          };
          setAccessControl((prev) => ({
            ...prev,
            permission: [...prev.permission, newObject],
          }));
        });
      } else {
        const parent = _.find(accessControl.category, (category) => {
          return category.id === categoryItem.parent_id;
        });
        const newObject = {
          id: generateMaxId(),
          role_id: roleItem.id,
          control_id: parent.id,
          is_active: true,
          // actions: actions,
        };
        setAccessControl((prev) => ({
          ...prev,
          permission: [...prev.permission, newObject],
        }));
      }
    } else {
      const index = accessControl.permission.findIndex(
        (findItem) =>
          findItem.role_id === roleItem.id &&
          findItem.control_id === categoryItem.id,
      );
      if (index > -1) {
        const copyTargetObject = {
          ...targetObject,
          is_active: !targetObject.is_active,
          actions: !targetObject.is_active === true ? categoryItem.actions : {},
        };
        copyPermission[index] = copyTargetObject;
        setAccessControl((prev) => ({
          ...prev,
          permission: copyPermission,
        }));
      }
      if (categoryItem.parent_id === 0) {
        const filterCategory = _.filter(accessControl.category, (category) => {
          return category.parent_id === categoryItem.id;
        });

        _.forEach(filterCategory, (category) => {
          let actions = {};
          _.map(category.actions, (name, key) => {
            actions[key] = true;
          });
          const index = accessControl.permission.findIndex(
            (findItem) =>
              findItem.role_id === roleItem.id &&
              findItem.control_id === category.id,
          );
          const copyTargetObject = {
            ...accessControl.permission[index],
            is_active: e.target.checked,
            actions: e.target.checked ? actions : {},
          };
          copyPermission[index] = copyTargetObject;
          setAccessControl((prev) => ({
            ...prev,
            permission: copyPermission,
          }));
        });
      } else {
        const parentIndex = _.findIndex(
          accessControl.permission,
          (permission) => {
            return (
              permission.control_id === categoryItem.parent_id &&
              permission.role_id === roleItem.id
            );
          },
        );
        if (e.target.checked) {
          const copyTargetObject = {
            ...accessControl.permission[parentIndex],
            is_active: e.target.checked,
            actions: e.target.checked
              ? accessControl.permission[parentIndex].actions
              : {},
          };
          copyPermission[parentIndex] = copyTargetObject;
          setAccessControl((prev) => ({
            ...prev,
            permission: copyPermission,
          }));
        }
      }
    }

    setEditCount((prev) => prev + 1);
  };
  const handleActionsClick = (e, role_id, control_id, action) => {
    const permission = [...accessControl.permission];
    const selectedPremissionIndex = permission.findIndex(
      (p) => p.role_id === role_id && p.control_id === control_id,
    );
    if (!permission[selectedPremissionIndex]) {
      permission.push({
        actions: {
          [action]: e.target.checked,
        },
        control_id,
        role_id,
        is_active: true,
        id: generateMaxId(),
      });
    } else {
      permission[selectedPremissionIndex].is_active = true;
      permission[selectedPremissionIndex].actions = {
        ...permission[selectedPremissionIndex].actions,
        [action]: e.target.checked,
      };
    }
    setEditCount((prev) => prev + 1);
    setAccessControl((prev) => {
      return {
        ...prev,
        permission,
      };
    });
  };
  const generateMaxId = () => {
    const maxIdObject = accessControl.permission.reduce(
      (prev, cur) => (cur.id > prev.id ? cur : prev),
      {
        id: "",
        role_id: "",
        control: "",
        is_active: false,
      },
    );
    return maxIdObject.id + 1;
  };
  const onClose = () => {
    setRoleDialog((prev) => ({ ...prev, open: !prev.open }));
  };

  const handleOnClickSave = async () => {
    await updateAccessControl(accessControl.permission).then((data) => {
      if (data && data.results) {
        setSnackMessage(`修改成功`);
        setEditCount(0);
      } else {
        setSnackMessage(`修改失敗`);
      }
      setSnackOpen(true);
      setTimeout(() => {
        setSnackOpen(false);
      }, 1500);
    });
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    if (editCount > 0) {
      e.preventDefault();
      const message =
        "Are you sure you want to leave? All provided data will be lost.";
      e.returnValue = message;
      return message;
    }
  };

  React.useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    if (editCount === 0) {
      fetchDept();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [editCount]);

  React.useEffect(() => {
    fetchAll();
  }, [selectedDept]);
  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={18}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`權限管理`}
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            <IconButton
              component="label"
              onClick={() =>
                setRoleDialog((prev) => ({ ...prev, open: !prev.open }))
              }
            >
              <AddOutlinedIcon />
            </IconButton>
            {/* Save Record */}
            <IconButton
              component="label"
              disabled={editCount <= 0 ? true : false}
              color={"primary"}
              onClick={() => handleOnClickSave()}
            >
              <SaveIcon />
            </IconButton>
          </div>
        }
      />

      <StyledPaper page={"yes"}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <Select
              value={selectedDept}
              onChange={(event) => {
                if (editCount > 0) {
                  alert("請先儲存當前設定");
                } else {
                  setSelectedDept(event.target.value);
                }
              }}
            >
              {department.map((dept) => {
                return (
                  <MenuItem key={dept.id} value={dept.id}>
                    {dept.name}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
      <RoleManageCreateDialog
        {...{
          ...roleDialog,
          department,
          onClose,
          fetchAll,
          setSnackMessage,
          setSnackOpen,
          setSnackSeverity,
        }}
      />
      {/* </ThemeProvider> */}
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ zIndex: 99, background: "white" }}>
                    <TableCell
                      sx={{ zIndex: 99, background: "white" }}
                    ></TableCell>
                    {accessControl.roleType.map((item, index) => (
                      <TableCell
                        align="center"
                        key={index}
                        sx={{ zIndex: 99, background: "white" }}
                      >
                        {item.role_types_name}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {accessControl.category.map((categoryItem, index) => {
                      return (
                        <React.Fragment>
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                fontWeight:
                                  categoryItem.parent_id === 0
                                    ? "bold"
                                    : "normal",
                                position: "sticky",
                                left: 0,
                                background: "white",
                                zIndex: 98,
                              }}
                            >
                              {categoryItem.parent_id !== 0 ? " - " : ""}
                              {categoryItem.category}
                            </TableCell>
                            {accessControl.roleType.map((roleItem, index) => {
                              const targetObject =
                                accessControl.permission.find(
                                  (findItem) =>
                                    findItem.role_id === roleItem.id &&
                                    findItem.control_id === categoryItem.id,
                                );
                              return (
                                <TableCell key={index} align="center">
                                  <Checkbox
                                    // disableRipple={targetObject?.is_lock}
                                    color="success"
                                    checked={
                                      targetObject
                                        ? targetObject.is_active === true
                                          ? true
                                          : false
                                        : false
                                    }
                                    key={`${roleItem.name}-${categoryItem.id}`}
                                    onChange={(e) =>
                                      handlePermissionClick(
                                        e,
                                        targetObject,
                                        roleItem,
                                        categoryItem,
                                      )
                                    }
                                    inputProps={{ "aria-label": "controlled" }}
                                  />
                                </TableCell>
                              );
                            })}
                          </TableRow>
                          {_.map(categoryItem.actions, (action, key) => {
                            return (
                              <TableRow key={key}>
                                <TableCell
                                  sx={{
                                    position: "sticky",
                                    left: 0,
                                    background: "white",
                                    zIndex: 98,
                                  }}
                                >
                                  <Typography
                                    variant="inherit"
                                    component="div"
                                    sx={{ fontStyle: "italic", ml: 3 }}
                                  >
                                    *{action}
                                  </Typography>
                                </TableCell>
                                {accessControl.roleType.map(
                                  (roleItem, index) => {
                                    const targetObject =
                                      accessControl.permission.find(
                                        (findItem) =>
                                          findItem.role_id === roleItem.id &&
                                          findItem.control_id ===
                                            categoryItem.id,
                                      );
                                    let is_checked = false;
                                    if (targetObject?.actions) {
                                      is_checked = targetObject.actions[key];
                                    }
                                    return (
                                      <TableCell key={index} align="center">
                                        <Checkbox
                                          // disableRipple={targetObject?.is_lock}
                                          onChange={(e) =>
                                            handleActionsClick(
                                              e,
                                              roleItem.id,
                                              categoryItem.id,
                                              key,
                                            )
                                          }
                                          key={`${roleItem.id}-${categoryItem.id}`}
                                          color="success"
                                          checked={is_checked}
                                          inputProps={{
                                            "aria-label": "controlled",
                                          }}
                                        />
                                      </TableCell>
                                    );
                                  },
                                )}
                              </TableRow>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default RoleAccessManagePage;
